import Axios from "axios";
import { getParcelTerminals } from "./parcelTerminalAction";

export const setCountriesOptions = () => async (dispatch, getStates) => {
  try {
    console.log('*** Fetching countries options... ***')
    const { countries, countries_loading } = getStates().options;
    if (countries_loading) return;
    dispatch(setOption('countries_loading', true))
    if (countries.length > 0) return console.log("The country is already taken")
    const { data } = await Axios.get('/api/v1/countries');
    dispatch({
      type: "SET_OPTIONS",
      payload: {
        countries: data.data.map(d => ({
          ...d,
          label: d.en_name,
          value: d.id
        }))
      },
    });
    return { success: true };
  } catch (err) {
    console.log("ERROR: fetching countries options:", { err })
    return { success: false };
  } finally {
    dispatch(setOption('countries_loading', false))
  }
};

export const setParcelTerminalsOptions = () => async (dispatch, getStates) => {
  try {
    const { parcel_terminals, parcel_terminals_loading } = getStates().options;
    if (parcel_terminals_loading) return;
    dispatch(setOption('parcel_terminals_loading', true))
    if (Object.values(parcel_terminals.dpd).length > 0) return console.log("The parcel_terminals is already taken")
    const { data } = await getParcelTerminals();
    dispatch({
      type: "SET_OPTIONS",
      payload: {
        parcel_terminals: data
      },
    });
    return { success: true };
  } catch (err) {
    console.log('setParcelTerminalsOptions: ', { err })
    return { success: false };
  } finally {
    dispatch(setOption('parcel_terminals_loading', false))
  }
}

export const setPickupAddressesOptions = () => async (dispatch, getStates) => {
  try {
    const { pickup_addresses, pickup_addresses_loading } = getStates().options;
    if (pickup_addresses_loading) return;
    dispatch(setOption('pickup_addresses_loading', true))
    if (pickup_addresses.length > 0) return console.log("The pickupAddresses is already taken")
    const { data } = await Axios.get('/api/v1/pickup_addresses');
    dispatch({
      type: "SET_OPTIONS",
      payload: {
        pickup_addresses: data.data.map(d => ({
          ...d,
          label: `${d.code} - ${d.address},  ${d.city}`,
          value: d.id,
        }))
      },
    });
    return { success: true };
  } catch (err) {
    return { success: false };
  } finally {
    dispatch(setOption('pickup_addresses_loading', false))
  }
}


export const setOrderShopsOptions = (type = 'simple') => async (dispatch, getStates) => {
  try {
    const { order_shops, order_shops_loading } = getStates().options;
    const { user_role: { shop_ids } } = getStates().auth.user;
    if (type == 'simple' && !shop_ids) return
    if (order_shops_loading) return;
    dispatch(setOption('order_shops_loading', true))
    if (type == 'simple' && order_shops.length == shop_ids.length && shop_ids.every((id) => !!order_shops.find(d => d.value == id))) return console.log("The order_shops is already taken")
    const { data } = await Axios.get(`/api/v1/order_shops?${type == 'all' ? '' : shop_ids.map(shop_id => `&q[id_in][]=${shop_id}`).join("")}`);
    dispatch({
      type: "SET_OPTIONS",
      payload: {
        order_shops: data.shops
      }
    })

    return { success: true };
  } catch (err) {
    console.log('ERROR: setOrderShopsOptions', err)
    return { success: false };
  } finally {
    dispatch(setOption('order_shops_loading', false))
  }
}


const setOption = (name, value) => {
  return {
    type: "SET_OPTIONS",
    payload: {
      [name]: value
    }
  };
};
